import axios from 'axios'
import store from "../store";

const service = axios.create({
    timeout: 200000,
    headers: {
        'Content-Type': 'application/json; charset=utf-8;',
    },
    withCredentials: true
})

service.interceptors.request.use(
    config => {
        if (store.getters.token) {
            config.headers["Authorization"] = `Bearer ${store.getters.token}`;
        }
        config.data = JSON.stringify(config.data);
        return config;
    }, function (error) {
        return Promise.reject(error);
    }
);

service.interceptors.response.use(
    response => {
        const res = response.data;
        if(res.code == 403){
            return Promise.reject('error');
        }
        return response
    },
    error=>{
        return Promise.reject(error)
    }
)
export default service


// WEBPACK FOOTER //
// ./src/api/fetch-json.js